import HttpClient from '../../../services/http-client';
import { IBudgetProgramFilterRequest } from '../../../../model/sge/budget-program/request/budget-program-filter-request';
import { IBudgetProgramAddEditRequest } from '../../../../model/sge/budget-program/request/budget-program-add-edit-request';
import { IBudgetProgramResponse } from '../../../../model/sge/budget-program/response/budget-program-response';

const defaultPath = 'BudgetProgram';

const list = async (params?: IBudgetProgramFilterRequest): Promise<IBudgetProgramResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params
    }).then((response) => response.data);
};

const getById = async (id: number): Promise<IBudgetProgramResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: IBudgetProgramAddEditRequest): Promise<IBudgetProgramResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: { budgetUnitId: params.budgetUnitId, code: params.code, name: params.name }
    }).then((response) => response.data);
};

const edit = async (id: number, params: IBudgetProgramAddEditRequest): Promise<IBudgetProgramResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: { code: params.code, name: params.name }
    }).then((response) => response.data);
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const BudgetProgramAppService = { list, getById, add, edit, remove };
export default BudgetProgramAppService;
